/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const BalanceStatus = {
    Outstanding: 'Outstanding',
    Paid: 'Paid',
    PartiallyPaid: 'PartiallyPaid'
} as const;
export type BalanceStatus = typeof BalanceStatus[keyof typeof BalanceStatus];


export function instanceOfBalanceStatus(value: any): boolean {
    for (const key in BalanceStatus) {
        if (Object.prototype.hasOwnProperty.call(BalanceStatus, key)) {
            if (BalanceStatus[key as keyof typeof BalanceStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function BalanceStatusFromJSON(json: any): BalanceStatus {
    return BalanceStatusFromJSONTyped(json, false);
}

export function BalanceStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): BalanceStatus {
    return json as BalanceStatus;
}

export function BalanceStatusToJSON(value?: BalanceStatus | null): any {
    return value as any;
}

export function BalanceStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): BalanceStatus {
    return value as BalanceStatus;
}

